import { Directive, EventEmitter, HostBinding, HostListener, Input, Output, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class MegaSimpleDndListDirective {
    constructor() {
        this.hoverStyle = 'hover';
        this.dragStyle = 'draggin';
        this.isSwap = false;
        this.dropped = new EventEmitter();
        this.draggable = true;
        this.swapItemsInArray = (/**
         * @param {?} oldIndex
         * @param {?} newIndex
         * @param {?} originalArray
         * @return {?}
         */
        (oldIndex, newIndex, originalArray) => {
            [originalArray[oldIndex], originalArray[newIndex]] = [originalArray[newIndex], originalArray[oldIndex]];
            return originalArray;
        });
        this.reorderArray = (/**
         * @param {?} oldIndex
         * @param {?} newIndex
         * @param {?} originalArray
         * @return {?}
         */
        (oldIndex, newIndex, originalArray) => {
            /** @type {?} */
            const movedItem = originalArray.find((/**
             * @param {?} item
             * @param {?} index
             * @return {?}
             */
            (item, index) => index === oldIndex));
            /** @type {?} */
            const remainingItems = originalArray.filter((/**
             * @param {?} item
             * @param {?} index
             * @return {?}
             */
            (item, index) => index !== oldIndex));
            /** @type {?} */
            const reorderedItems = [
                ...remainingItems.slice(0, newIndex),
                movedItem,
                ...remainingItems.slice(newIndex)
            ];
            return reorderedItems;
        });
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    dragstart($event) {
        $event.dataTransfer.setData('indexSource', this.index.toString());
        $event.srcElement.classList.add(this.dragStyle);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    dragend($event) {
        $event.srcElement.classList.remove(this.dragStyle);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    dragenter($event) {
        if (!$event.srcElement.classList.contains(this.dragStyle)) { // Only add the hoverStyle to the other elements
            $event.srcElement.classList.add(this.hoverStyle);
        }
        $event.preventDefault();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    dragleave($event) {
        $event.srcElement.classList.remove(this.hoverStyle);
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    drop($event) {
        $event.srcElement.classList.remove(this.hoverStyle);
        /** @type {?} */
        const indexSource = Number($event.dataTransfer.getData('indexSource'));
        this.items = (this.isSwap)
            ? this.swapItemsInArray(indexSource, this.index, this.items)
            : this.reorderArray(indexSource, this.index, this.items);
        this.dropped.emit(this.items);
        $event.preventDefault();
    }
    /**
     * @param {?} $event
     * @return {?}
     */
    dragover($event) {
        $event.preventDefault(); // prevent default to allow drop
    }
}
MegaSimpleDndListDirective.ɵfac = function MegaSimpleDndListDirective_Factory(t) { return new (t || MegaSimpleDndListDirective)(); };
MegaSimpleDndListDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: MegaSimpleDndListDirective, selectors: [["", "megaSimpleDndList", ""]], hostVars: 1, hostBindings: function MegaSimpleDndListDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("dragstart", function MegaSimpleDndListDirective_dragstart_HostBindingHandler($event) { return ctx.dragstart($event); })("dragend", function MegaSimpleDndListDirective_dragend_HostBindingHandler($event) { return ctx.dragend($event); })("dragenter", function MegaSimpleDndListDirective_dragenter_HostBindingHandler($event) { return ctx.dragenter($event); })("dragleave", function MegaSimpleDndListDirective_dragleave_HostBindingHandler($event) { return ctx.dragleave($event); })("drop", function MegaSimpleDndListDirective_drop_HostBindingHandler($event) { return ctx.drop($event); })("dragover", function MegaSimpleDndListDirective_dragover_HostBindingHandler($event) { return ctx.dragover($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("draggable", ctx.draggable);
    } }, inputs: { hoverStyle: "hoverStyle", dragStyle: "dragStyle", isSwap: "isSwap", items: "items", index: "index" }, outputs: { dropped: "dropped" } });
/** @nocollapse */
MegaSimpleDndListDirective.ctorParameters = () => [];
MegaSimpleDndListDirective.propDecorators = {
    items: [{ type: Input }],
    index: [{ type: Input }],
    hoverStyle: [{ type: Input }],
    dragStyle: [{ type: Input }],
    isSwap: [{ type: Input }],
    dropped: [{ type: Output }],
    draggable: [{ type: HostBinding }],
    dragstart: [{ type: HostListener, args: ['dragstart', ['$event'],] }],
    dragend: [{ type: HostListener, args: ['dragend', ['$event'],] }],
    dragenter: [{ type: HostListener, args: ['dragenter', ['$event'],] }],
    dragleave: [{ type: HostListener, args: ['dragleave', ['$event'],] }],
    drop: [{ type: HostListener, args: ['drop', ['$event'],] }],
    dragover: [{ type: HostListener, args: ['dragover', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MegaSimpleDndListDirective, [{
        type: Directive,
        args: [{
                selector: '[megaSimpleDndList]'
            }]
    }], function () { return []; }, { hoverStyle: [{
            type: Input
        }], dragStyle: [{
            type: Input
        }], isSwap: [{
            type: Input
        }], dropped: [{
            type: Output
        }], draggable: [{
            type: HostBinding
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    dragstart: [{
            type: HostListener,
            args: ['dragstart', ['$event']]
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    dragend: [{
            type: HostListener,
            args: ['dragend', ['$event']]
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    dragenter: [{
            type: HostListener,
            args: ['dragenter', ['$event']]
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    dragleave: [{
            type: HostListener,
            args: ['dragleave', ['$event']]
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    drop: [{
            type: HostListener,
            args: ['drop', ['$event']]
        }], items: [{
            type: Input
        }], 
    /**
     * @param {?} $event
     * @return {?}
     */
    dragover: [{
            type: HostListener,
            args: ['dragover', ['$event']]
        }], index: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxMegaSimpleDragDropListModule {
}
NgxMegaSimpleDragDropListModule.ɵfac = function NgxMegaSimpleDragDropListModule_Factory(t) { return new (t || NgxMegaSimpleDragDropListModule)(); };
NgxMegaSimpleDragDropListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxMegaSimpleDragDropListModule });
NgxMegaSimpleDragDropListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMegaSimpleDragDropListModule, [{
        type: NgModule,
        args: [{
                declarations: [MegaSimpleDndListDirective],
                imports: [],
                exports: [MegaSimpleDndListDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxMegaSimpleDragDropListModule, { declarations: [MegaSimpleDndListDirective], exports: [MegaSimpleDndListDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MegaSimpleDndListDirective, NgxMegaSimpleDragDropListModule };

